const rawBackendBase = import.meta.env.VITE_BACKEND_BASE_URL;
export const BACKEND_BASE_URL = rawBackendBase
  ? (rawBackendBase.startsWith("http")
      ? rawBackendBase
      : `${window.location.protocol}//${rawBackendBase}`)
  : window.location.origin;

